export const DialogResponseEnum = {
    Cancel: 0,
    Close: 0,
    Ok: 1
}
